import React, { useCallback, useState } from "react";
import { toast } from "react-toastify";
import FormHeader from "./Header";
import FeeBreakdown from "./FeeBreakdown";
import IncludedServicesSection from "./IncludedServicesSection";
import { useLocation } from "react-router-dom";
import { useIdleTimer } from "../../hooks/useIdleTimer";
import { useNavigate } from "react-router-dom";
import ProblemSolutionCard from "./ProblemSolutionCard";
import "./index.scss";

const LeadPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const data = state?.data || {};
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const timeoutMinutes = 10;

  const [_, setUserName] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [afsData] = useState(data.afsData);
  const [lead] = useState(data.lead);
  const [hasTimedOut, setHasTimedOut] = useState(false);

  useIdleTimer({
    onIdle: async () => {
      if (hasTimedOut) return;
      setHasTimedOut(true);

      toast.warn("Your session has expired. Please start again", {
        position: "bottom-center",
        autoClose: 10000,
        style: {
          fontSize: "12px",
          maxWidth: "600px",
          margin: "auto",
          textAlign: "center",
        },
      });

      try {
        // 👇 New: GET API call using quote number
        const response = await fetch(
          `${apiBaseUrl}/v1/api/lead/on-idle/${lead.quoteNumber}`
        );
        if (!response.ok) {
          throw new Error(`Idle GET request failed: ${response.status}`);
        }

        const result = await response.json();
        console.log("✅ Idle GET API response:", result);
      } catch (e) {
        console.error("❌ Idle GET call failed:", e.message);
        toast.error("Failed to log idle session with server.");
      } finally {
        navigate("/");
      }
    },
    onActive: () => {},
    timeout: timeoutMinutes * 60 * 1000,
    isEnabled: true,
  });

  const downloadLeadPdf = useCallback(
    async (quoteNumber) => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/v1/api/lead/download/${quoteNumber}`,
          { method: "GET" }
        );

        if (!response.ok) {
          const errorBody = await response.text();
          throw new Error(`Download failed (${response.status}): ${errorBody}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `lead-${quoteNumber}.pdf`;
        a.click();

        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("❌ Error downloading PDF:", error.message);
      }
    },
    [apiBaseUrl]
  );

  const handleNext = async (name) => {
    setUserName(name);
    setIsDownloading(true);
    try {
      await downloadLeadPdf(lead.quoteNumber);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="lead_page">
      {isDownloading && (
        <div className="pdf-loader-overlay">
          <div className="pdf-loader-message">
            <p>
              📄 Processing... Downloading your quote and redirecting you to the
              payment page.
            </p>
          </div>
        </div>
      )}

      <FormHeader />
      <ProblemSolutionCard lead={lead} />
      <FeeBreakdown afsData={afsData} />
      <IncludedServicesSection
        onNext={handleNext}
        afsData={afsData}
        lead={lead}
      />
    </div>
  );
};

export default LeadPage;
